
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  standalone: true,
  selector: 'app-reauth-overlay',
  imports: [CommonModule, MatButtonModule],
  template: `
    <div class="panel">
      <h3>Session paused</h3>
      <p>Your session requires re-authentication.</p>
      <button mat-raised-button color="primary" (click)="reauth()">Re-authenticate</button>
    </div>
  `,
  styles: [`.panel{background:white;padding:24px;border-radius:8px;box-shadow:0 8px 24px rgba(0,0,0,.2);text-align:center;}`]
})
export class ReauthOverlayComponent {
  reauth(){ window.dispatchEvent(new CustomEvent('reauth-click')); }
}
